<template>
  <Card :bordered="true" class="customflow-container" dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <Select v-model="sortWay" :transfer="false" style="width: 80px; height: 32px" @on-change="getData">
        <Option :value="1">{{ $t('common.all') }}</Option>
        <Option :value="2">{{ $t('home.without_manual_create') }}</Option>
      </Select>
    </a>
    <Spin size="large" v-show="isLoading" fix></Spin>
    <div ref="todolist" class="charts-body">
      <div id="todo-list-echarts"></div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import * as echarts from 'echarts';
import moment from 'moment';
// import { doughnutOption } from '../../../config/echarts';
import { privileageAccess } from '../../../mixins/privileage';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';
import { tooltipRefash } from '../echartUtil';
export default {
  mixins: [privileageAccess],
  name: 'todo-list-card',
  data() {
    return {
      chartLegends: [],
      options: {},
      width: 0,
      myChart: null,
      sortWay: 1,
      isLoading: false,
      timer: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.width = this.$refs.todolist.offsetWidth;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    getData() {
      api
        .getTodoList({ containsManual: this.sortWay })
        .then(res => {
          this.data = res;
          this.isLoading = false;
          this.formatChartData(this.data);
        })
        .catch(error => {
          console.error(`${this.$t('home.error_gettodolist')}：${error}`);
        });
    },
    formatChartData(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('todo-list-echarts'), null, { renderer: 'svg' });
      const totalNum = data.notReformNum + data.notReviewNum + data.solveProblemNum;
      let option = {
        tooltip: {
          trigger: 'item',
          position: 'left',
        },
        color: ['#5789ff', '#f90', '#7ED321'],
        grid: [
          {
            right: '3%',
          },
        ],
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          left: '12%',
          top: '28%',
          itemHeight: 12, //图例的高度
          itemWidth: 12,
          itemGap: 20,
          icon: 'circle',
          textStyle: {
            rich: {
              n: {
                display: 'inline-block',
                width: 40,
                color: '#E6E6E6',
              },
              v: {
                display: 'inline-block',
                width: 40,
                color: '#E6E6E6',
              },
            },
          },
          //图例-待整改，待复检，已完成
          data: [this.$t('home.notSolveProblemNum'), this.$t('home.notReviewNum'), this.$t('home.solveProblemNum')],
          formatter: function (name) {
            let index = 0;
            option.series[0].data.forEach((val, i) => {
              if (val.name === name) {
                index = i;
              }
            });
            if (getLanguage() == 'zh-CN' || getLanguage() == 'zh-TW') {
              return `{n|${name}} {v|${option.series[0].data[index].value}}`;
            } else {
              return `{n|${name}}                 {v|${option.series[0].data[index].value}}`;
            }
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['70%', '80%'],
            center: ['72%', '50%'], //距离左右，上下距离的百分比
            avoidLabelOverlap: false,
            hoverOffset: 5,
            label: {
              show: true,
              position: 'center',
              formatter: `{b|${totalNum}}\n${this.$t('common.allProblem')}`,
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#ffffff',
                  lineHeight: '26',
                },
              },
            },
            data: [
              {
                value: data.notReformNum,
                name: this.$t('home.notSolveProblemNum'),
              },
              {
                value: data.notReviewNum,
                name: this.$t('home.notReviewNum'),
              },
              {
                value: data.solveProblemNum,
                name: this.$t('home.solveProblemNum'),
              },
            ],
          },
        ],
      };

      // let options = doughnutOption;
      // options.title.text = `${totalNum}\n${this.$t('common.allProblem')}`;
      // options.legend.formatter = function(name) {
      //   let index = 0;
      //   options.legend.data.forEach((val, i) => {
      //     if (val === name) {
      //       index = i;
      //     }
      //   });
      //   return `{n|${name}}{v|${seriesData[index].value}}`;
      // };

      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
      let dataLen = option.series[0].data.length;
      this.timer = tooltipRefash(myChart, dataLen);
    },
    goToProblem() {
      const params = {
        startTime: moment().startOf('month').format('YYYY-MM-DD'), 
        endTime: moment().endOf('month').format('YYYY-MM-DD'),
        status: '3, 4, 5', //待复检，已完成，待整改
        from: 'homepage'
      };
      const queryParams = Object.keys(params)
       .map(key => `${key}=${encodeURIComponent(params[key])}`)
       .join('&');
     
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_Boss, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: `/patrol-shop/index.html/problem/data-manage?${queryParams}`, //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
.customflow-container {
  .charts-body {
    @include wh100;
    #todo-list-echarts {
      width: 100%;
      height: 100%;
    }
  }
  .echart-container {
    @include wh100;
  }
}
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
  .ivu-select-selection {
    background: none !important;
    border: none;
    border: 0.5px solid #999999;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
</style>
